// src/components/AsistenteRag.jsx
// Asistente RAG institucional (Web Component <rag-widget> cargado desde URL externa).
// Montar UNA sola vez (ver Layout.jsx). Guía: integracion-react.md
import { useEffect } from "react";

const SCRIPT = "https://tramitedocumentario.transformaciondigitalcusco.in/rag-widget/rag-widget.js?v=9";

const RAG_API = process.env.REACT_APP_RAG_API;
const RAG_KEY = process.env.REACT_APP_RAG_KEY;

function cargarScript() {
  if (document.querySelector(`script[src="${SCRIPT}"]`)) return;
  const s = document.createElement("script");
  s.src = SCRIPT;
  s.defer = true;
  document.head.appendChild(s);
}

/**
 * @param {string} [token]    JWT del usuario (solo si el backend lo firma)
 * @param {string} [tokenUrl] Alternativa: endpoint del backend que devuelve {"token": "..."}
 */
export default function AsistenteRag({ token, tokenUrl }) {
  useEffect(() => {
    if (!RAG_API || !RAG_KEY) {
      console.warn("[AsistenteRag] Falta REACT_APP_RAG_API o REACT_APP_RAG_KEY; el asistente no se carga.");
      return undefined;
    }
    cargarScript();
    const el = document.createElement("rag-widget");
    const attrs = {
      api: RAG_API,
      key: RAG_KEY,
      titulo: "Asistente institucional",
      subtitulo: "Responde con documentos de la institución",
      bienvenida: "Hola, puedo orientarle sobre la **normativa y procedimientos** de la institución.",
      sugerencias: "¿Cuáles son los objetivos del PEI?|¿Qué ejes estratégicos tiene la institución?",
      ...(tokenUrl ? { "token-url": tokenUrl } : {}),
    };
    Object.entries(attrs).forEach(([k, v]) => v != null && el.setAttribute(k, v));
    document.body.appendChild(el);
    return () => el.remove();
  }, [tokenUrl]);

  // Entregar o renovar el JWT cuando cambie
  useEffect(() => {
    if (!token || !window.customElements) return;
    customElements
      .whenDefined("rag-widget")
      .then(() => document.querySelector("rag-widget")?.setToken(token));
  }, [token]);

  return null;
}
